import * as strings from "../strings";

import {
	IconSpeed,
	IconHwSeatbelt,
	IconHwBraking,
	IconHwAcceleration,
	IconHwCornering,
	IconHwExcessiveSpeed,
} from "assets";

const per100KM = (value: any) =>
	value.mileage < 100_000
		? value.total
		: (value.total / (value.mileage / 1000)) * 100;

export const HW_PILLAR_SPEED = {
	type: "hw_speed",
	id: "hw_speed",
	icon: IconSpeed,
	calc: (value: any) => {
		return (value.total / value.engineEvents) * 100;
	},
	strings: {
		name: strings.PILLAR_HW_SPEED_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP,
		description: () => strings.PILLAR_HW_SPEED_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT_PLURAL,
		suffix: "%",
		fullName: strings.PILLAR_SPEED_FULL_NAME,
		fullNamePlural: strings.PILLAR_SPEED_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_SPEED_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_SPEED_TOOLTIP_TITLE,
			copy: strings.PILLAR_SPEED_TOOLTIP_COPY,
			fleet: strings.PILLAR_SPEED_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_SPEED_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "engineEvents",
		key: "hw_speed",
		stat: "hw_speed",
		benchmarkStat: "speed",
		boxplotKey: "hw_speed",
	},
};

export const HW_PILLAR_SEATBELT = {
	type: "hw_seatbelt",
	id: "hw_seatbelt",
	icon: IconHwSeatbelt,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_SEATBELT_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_SEATBELT_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_SEATBELT_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_seatbelt",
		stat: "hw_seatbelt",
		benchmarkStat: "hw_seatbelt",
		boxplotKey: "hw_seatbelt",
	},
};

export const HW_PILLAR_ACCELERATION = {
	type: "hw_acceleration",
	id: "hw_acceleration",
	icon: IconHwAcceleration,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_ACCELERATION_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_ACCELERATION_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_ACCELERATION_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_acceleration",
		stat: "hw_acceleration",
		benchmarkStat: "hw_acceleration",
		boxplotKey: "hw_acceleration",
	},
};

export const HW_PILLAR_BRAKING = {
	type: "hw_braking",
	id: "hw_braking",
	icon: IconHwBraking,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_BRAKING_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_BRAKING_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_BRAKING_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_braking",
		stat: "hw_braking",
		benchmarkStat: "hw_braking",
		boxplotKey: "hw_braking",
	},
};

export const HW_PILLAR_CORNERING = {
	type: "hw_cornering",
	id: "hw_cornering",
	icon: IconHwCornering,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_CORNERING_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_CORNERING_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_CORNERING_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_cornering",
		stat: "hw_cornering",
		benchmarkStat: "hw_cornering",
		boxplotKey: "hw_cornering",
	},
};

export const HW_PILLAR_EXCESSIVE_SPEED = {
	type: "hw_excessive_speed",
	id: "hw_excessive_speed",
	icon: IconHwExcessiveSpeed,
	calc: (value: any) => {
		return (value.total / value.engineEvents) * 100;
	},
	strings: {
		name: strings.PILLAR_HW_EXCESSIVE_SPEED_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP,
		description: () => strings.PILLAR_HW_EXCESSIVE_SPEED_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT_PLURAL,
		suffix: "%",
		fullName: strings.PILLAR_SPEED_FULL_NAME,
		fullNamePlural: strings.PILLAR_SPEED_FULL_NAME_PLURAL,
		xAxisTitle: (imperial: boolean) =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_EXCESSIVE_SPEED_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_SPEED_TOOLTIP_TITLE,
			copy: strings.PILLAR_SPEED_TOOLTIP_COPY,
			fleet: strings.PILLAR_SPEED_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_SPEED_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "engineEvents",
		key: "hw_excessive_speed",
		stat: "hw_excessive_speed",
		benchmarkStat: "speed",
		boxplotKey: "hw_excessive_speed",
	},
};

export const PILLARS = [
	HW_PILLAR_SPEED,
	HW_PILLAR_EXCESSIVE_SPEED,
	HW_PILLAR_SEATBELT,
	HW_PILLAR_ACCELERATION,
	HW_PILLAR_BRAKING,
	HW_PILLAR_CORNERING,
];
